<template>
  <Preparing v-if="isPreparing" />
  <div v-if="!isPreparing">
    <div class="container-fluid">
      <ul class="nav nav-tabs generic-tab pb-30px" id="myTab" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            id="inProgress-tab"
            data-toggle="tab"
            href="#inProgress"
            role="tab"
            aria-controls="inProgress"
            aria-selected="true"
          >
            پروژه های در حال انجام
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="done-tab"
            data-toggle="tab"
            href="#done"
            role="tab"
            aria-controls="done"
            aria-selected="false"
          >
            پروژه های انجام شده
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="needChange-tab"
            data-toggle="tab"
            href="#needChange"
            role="tab"
            aria-controls="needChange"
            aria-selected="false"
          >
            پروژه های نیاز به تغییر
          </a>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane active"
          id="inProgress"
          role="tabpanel"
          aria-labelledby="inProgress-tab"
        >
          <Preparing v-if="isSorting" />
          <div v-if="!isSorting">
            <div class="filter-bar mb-4">
              <div
                class="filter-bar-inner d-flex flex-wrap align-items-center justify-content-between"
              >
                <!-- <div class="d-flex justify-content-center col-lg-9">
                  <Dropdown :loading="false" class="form-control form-control-register primCom mr-2"
                    v-model="selectedfilter" :options="filters" optionLabel="name" optionValue="code"
                    placeholder="فیلتر بر اساس دسته بندی" />
                  <Dropdown :loading="false" class="form-control form-control-register primCom mr-2"
                    v-model="selectedService" :options="services" optionLabel="Name" optionValue="Id"
                    placeholder="همه سرویس ها" />
                  <Dropdown :loading="false" class="form-control form-control-register primCom mr-2"
                    v-model="selectedfilterCat" :options="filterCats" optionLabel="name" optionValue="code"
                    placeholder="فیلتر بر اساس رشته" />
                </div> -->
                <p v-if="inProgressPapers.length === 0" class="col-lg-3">
                  شما پروژه ی در حال انجام ندارید
                </p>
                <p v-if="inProgressPapers.length !== 0" class="col-lg-3">
                  شما
                  <span class="text-black">{{ inProgressPapers.length }}</span>
                  پروژه در حال انجام دارید
                </p>
              </div>
            </div>
            <Preparing v-if="isSorting" />
            <!-- <NoArticle v-if="displayedpapers.length === 0"></NoArticle> -->
            <div v-if="!isSorting && inProgressPapers.length !== 0" class="row">
              <div v-for="p in inProgressPapers" :key="p.Id" class="col-lg-6">
                <div
                  @click="sendPaper(p)"
                  data-target="#assignModal"
                  data-toggle="modal"
                  class="card card-item card-preview card-item-list-layout"
                  data-tooltip-content="#tooltip_content_1"
                >
                  <!-- end card-image -->
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <h6 class="ribbon ribbon-blue-bg fs-14 mb-3">
                        {{ parseDates(p.DateCreate) }}
                      </h6>
                      <h6
                        class="ribbon ribbon-blue-bg fs-14 mb-3"
                        :style="[
                          p.Priority === 0
                            ? { color: 'green' }
                            : p.Priority === 1
                            ? { color: 'orange' }
                            : { color: 'red' },
                        ]"
                      >
                        {{
                          p.Priority === 0
                            ? "عادی"
                            : p.Priority === 1
                            ? "فوری"
                            : "خیلی فوری"
                        }}
                      </h6>
                    </div>
                    <h6 class="card-title">
                      <a href="#">نوع پروژه : {{ p.PaperServiceTypeName }}</a>
                    </h6>
                    <p class="card-text">
                      رشته مرتبط :
                      <span
                        :style="[
                          thisIsMyField(p.Field)
                            ? { color: 'green' }
                            : { color: 'orange' },
                        ]"
                        >{{ fieldName(p.Field) }}</span
                      >
                    </p>
                    <div class="rating-wrap d-flex align-items-center py-2">
                      <div class="review-stars">
                        قیمت پروژه :
                        <span class="rating-number font-weight-regular"
                          >{{ parseInt(p.TotalPrice) }} تومان</span
                        >
                        <span style="color: green"> درآمد شما : </span>
                        <span class="rating-number font-weight-regular"
                          >{{ calcIncome(parseInt(p.TotalPrice)) }} تومان</span
                        >
                      </div>
                    </div>
                    <!-- end rating-wrap -->
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <p class="card-price text-black font-weight-regular">
                        تعداد کلمات این پروژه {{ p.TotalWord }} کلمه است
                      </p>
                      <div
                        class="icon-element icon-element-sm shadow-sm cursor-pointer"
                        title="ارسال"
                      >
                        <i
                          data-toggle="modal"
                          data-target="#assignModal"
                          class="la la-plus"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <!-- end card-body -->
                </div>
                <!-- end card -->
              </div>
            </div>
            <!-- end row -->
            <div
              v-if="filteredinProgressPapers.length > perPage"
              class="text-center pt-3"
            >
              <nav aria-label="مثال ناوبری صفحه" class="pagination-box">
                <ul class="pagination justify-content-center">
                  <li
                    v-if="page != 1"
                    @click="
                      page--;
                      scrollToTop();
                    "
                    class="page-item crToPoi"
                  >
                    <a class="page-link" aria-label="قبلی"
                      ><span aria-hidden="true"
                        ><i class="la la-arrow-right"></i></span
                      ><span class="sr-only">قبلی</span></a
                    >
                  </li>
                  <li class="page-item active">
                    <a class="page-link">{{ page }}</a>
                  </li>
                  <li
                    @click="
                      page++;
                      scrollToTop();
                    "
                    v-if="page > pages.length"
                    class="page-item crToPoi"
                  >
                    <a class="page-link" aria-label="بعد"
                      ><span aria-hidden="true"
                        ><i class="la la-arrow-left"></i></span
                      ><span class="sr-only">بعد</span></a
                    >
                  </li>
                </ul>
              </nav>
              <p class="fs-14 pt-1">
                نمایش {{ perPage * page - perPage + 1 }}-{{
                  perPage * page <= filteredinProgressPapers.length
                    ? perPage * page
                    : filteredinProgressPapers.length
                }}
                از {{ filteredinProgressPapers.length }} نتیجه
              </p>
            </div>
          </div>
        </div>
        <div
          class="tab-pane"
          id="done"
          role="tabpanel"
          aria-labelledby="done-tab"
        >
          <div class="dashboard-heading mb-5">
            <div class="row d-flex justify-content-between">
              <h3 class="col-9 fs-22 font-weight-regular">
                شما تا امروز {{ donePapers.length }} پروژه انجام داده اید
              </h3>
              <!-- <div class="col-3">
                <Dropdown :loading="false" class="form-control form-control-register primCom"
                  v-model="selectedfilterDonePapers" :options="donePapersFilters" optionLabel="name" optionValue="code"
                  placeholder="فیلتر بر اساس دسته بندی" />
              </div> -->
            </div>
          </div>
          <div class="col-12 mx-auto mt-3" v-if="!isPreparing">
            <DataTable
              ref="dt"
              :filters="tableFilters"
              class="p-datatable-sm"
              :value="donePapers"
              :paginator="true"
              :rows="10"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="نمایش {first} تا {last} از {totalRecords}"
            >
              <template #header>
                <div
                  class="primCom table-header flex flex-column md:flex-row md:justiify-content-between"
                >
                  <span class="p-input-icon-left">
                    <i class="pi pi-search" />
                    <InputText
                      class="form-control-register"
                      v-model="tableFilters['global'].value"
                      placeholder="جستجو کنید"
                    />
                  </span>
                </div>
              </template>
              <Column
                class="primCom"
                :style="{ textAlign: 'right' }"
                :sortable="true"
                field="DateCreate"
                header="تاریخ ایجاد"
              >
                <template #body="slotProps">
                  {{ parseDates(slotProps.data.DateCreate) }}
                </template>
              </Column>
              <Column
                class="primCom"
                :style="{ textAlign: 'right' }"
                field="PaperServiceTypeName"
                header="نوع پروژه"
              >
              </Column>
              <Column
                class="primCom"
                :style="{ textAlign: 'right' }"
                :sortable="true"
                field="TotalPrice"
                header="قیمت پروژه"
              >
                <template #body="slotProps">
                  {{ parseInt(slotProps.data.TotalPrice) }} تومان
                </template>
              </Column>
              <Column
                class="primCom"
                :style="{ textAlign: 'right' }"
                field="Priority"
                header="فوریت پروژه"
              >
                <template #body="slotProps">
                  <span
                    class="d-flex justify-content-center"
                    :style="[
                      slotProps.data.Priority === 0
                        ? { color: 'green' }
                        : slotProps.data.Priority === 1
                        ? { color: 'orange' }
                        : { color: 'red' },
                    ]"
                  >
                    {{
                      slotProps.data.Priority === 0
                        ? "عادی"
                        : slotProps.data.Priority === 1
                        ? "فوری"
                        : "خیلی فوری"
                    }}
                  </span>
                </template>
              </Column>
              <Column
                class="primCom"
                :style="{ textAlign: 'right' }"
                field="File"
                header="فایل اصلی"
                :exportable="false"
              >
                <template #body="slotProps">
                  <div class="media media-card align-items-center m-0 p-0">
                    <div class="text-center">
                      <a :href="domain + slotProps.data.File">
                        <i
                          style="font-size: 20px"
                          class="d-flex justify-content-center la la-cloud-download theme-btn"
                          title="دانلود"
                        ></i>
                      </a>
                    </div>
                  </div>
                </template>
              </Column>
              <Column
                class="primCom"
                :style="{ textAlign: 'right' }"
                field="FinalFile"
                header="فایل نهایی"
                :exportable="false"
              >
                <template #body="slotProps">
                  <div class="media media-card align-items-center m-0 p-0">
                    <div class="text-center">
                      <a :href="domain + slotProps.data.FinalFile">
                        <i
                          style="font-size: 20px"
                          class="d-flex justify-content-center la la-cloud-download theme-btn"
                          title="دانلود"
                        ></i>
                      </a>
                    </div>
                  </div>
                </template>
              </Column>
              <Column
                class="primCom"
                :style="{ textAlign: 'right' }"
                header="حذف فایل نهایی"
                :exportable="false"
              >
                <template #body="slotProps">
                  <div class="mt-0 media media-card align-items-center">
                    <div class="text-center">
                      <i
                        @click="deleteFinalFilePaper = slotProps.data"
                        data-toggle="modal"
                        data-target="#deleteFinalModal"
                        style="font-size: 25px"
                        class="crToPoi d-flex justify-content-center la la-trash"
                      ></i>
                    </div>
                  </div>
                </template>
              </Column>
              <Column
                class="primCom"
                :style="{ textAlign: 'right' }"
                header="اطلاعات بیشتر"
                :exportable="false"
              >
                <template #body="slotProps">
                  <div class="mt-0 media media-card align-items-center">
                    <div class="text-center">
                      <i
                        data-toggle="modal"
                        data-target="#moreModal"
                        @click="moreDataPaper = slotProps.data"
                        style="font-size: 20px"
                        class="crToPoi d-flex justify-content-center la la-eye"
                      ></i>
                    </div>
                  </div>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
        <div
          class="tab-pane"
          id="needChange"
          role="tabpanel"
          aria-labelledby="needChange-tab"
        >
          <div class="col-12 mx-auto mt-3" v-if="!isPreparing">
            <DataTable
              ref="dt"
              :filters="tableFilters"
              class="p-datatable-lg"
              :value="needChangePapers"
              :paginator="true"
              :rows="10"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="نمایش {first} تا {last} از {totalRecords}"
            >
              <template #header>
                <div
                  class="primCom table-header flex flex-column md:flex-row md:justiify-content-between"
                >
                  <span class="p-input-icon-left">
                    <i class="pi pi-search" />
                    <InputText
                      class="form-control-register"
                      v-model="tableFilters['global'].value"
                      placeholder="جستجو کنید"
                    />
                  </span>
                </div>
              </template>
              <Column
                class="primCom"
                :style="{ textAlign: 'right' }"
                :sortable="true"
                field="DateCreate"
                header="تاریخ ایجاد"
              >
                <template #body="slotProps">
                  {{ parseDates(slotProps.data.DateCreate) }}
                </template>
              </Column>
              <Column
                class="primCom"
                :style="{ textAlign: 'right' }"
                field="PaperServiceTypeName"
                header="نوع پروژه"
              >
              </Column>
              <Column
                class="primCom"
                :style="{ textAlign: 'right' }"
                :sortable="true"
                field="TotalPrice"
                header="قیمت پروژه"
              >
                <template #body="slotProps">
                  {{ parseInt(slotProps.data.TotalPrice) }} تومان
                </template>
              </Column>
              <Column
                class="primCom"
                :style="{ textAlign: 'right' }"
                field="Priority"
                header="فوریت پروژه"
              >
                <template #body="slotProps">
                  <span
                    class="d-flex justify-content-center"
                    :style="[
                      slotProps.data.Priority === 0
                        ? { color: 'green' }
                        : slotProps.data.Priority === 1
                        ? { color: 'orange' }
                        : { color: 'red' },
                    ]"
                  >
                    {{
                      slotProps.data.Priority === 0
                        ? "عادی"
                        : slotProps.data.Priority === 1
                        ? "فوری"
                        : "خیلی فوری"
                    }}
                  </span>
                </template>
              </Column>
              <Column
                class="primCom"
                :style="{ textAlign: 'right' }"
                field="File"
                header="فایل اصلی"
                :exportable="false"
              >
                <template #body="slotProps">
                  <div class="media media-card align-items-center m-0 p-0">
                    <div class="text-center">
                      <a :href="domain + slotProps.data.File">
                        <button
                          type="button"
                          class="btn theme-btn download-btn"
                        >
                          دانلود
                        </button>
                      </a>
                    </div>
                  </div>
                </template>
              </Column>
              <Column
                class="primCom"
                :style="{ textAlign: 'right' }"
                field="FinalFile"
                header="فایل نهایی"
                :exportable="false"
              >
                <template #body="slotProps">
                  <div class="media media-card align-items-center m-0 p-0">
                    <div class="text-center">
                      <a :href="domain + slotProps.data.FinalFile">
                        <button
                          type="button"
                          class="btn theme-btn download2-btn"
                        >
                          دانلود
                        </button>
                      </a>
                    </div>
                  </div>
                </template>
              </Column>
              <Column
                class="primCom"
                :style="{ textAlign: 'right' }"
                header="انجام پروژه"
                :exportable="false"
              >
                <template #body="slotProps">
                  <div class="mt-0 media media-card align-items-center">
                    <div class="text-center">
                      <i
                        data-toggle="modal"
                        data-target="#needChangeModal"
                        @click="sendNeedChangePaper(slotProps.data)"
                        style="font-size: 20px"
                        class="crToPoi d-flex justify-content-center la la-arrow-left"
                      ></i>
                    </div>
                  </div>
                </template>
              </Column>
              <Column
                class="primCom"
                :style="{ textAlign: 'right' }"
                header="اطلاعات بیشتر"
                :exportable="false"
              >
                <template #body="slotProps">
                  <div class="mt-0 media media-card align-items-center">
                    <div class="text-center">
                      <i
                        data-toggle="modal"
                        data-target="#moreModal"
                        @click="moreDataPaper = slotProps.data"
                        style="font-size: 20px"
                        class="crToPoi d-flex justify-content-center la la-eye"
                      ></i>
                    </div>
                  </div>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade modal-container" id="assignModal">
    <div class="modal-dialog bigMdl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">انجام پروژه</h3>
          <button type="button" class="close" data-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body px-5">
          <div class="row">
            <div class="col-6 py-4">
              <div class="list-group-item list-group-item-action d-flex">
                <div class="text-center">
                  <div class="course-overview-card">
                    <h3 class="txtRight fs-24 font-weight-regular pb-3">
                      درباره این پروژه
                    </h3>

                    <ul
                      class="generic-list-item generic-list-item-bullet fs-15"
                    >
                      <li class="txtRight">
                        این پروژه در تاریخ
                        {{ parseDates(finalizingPaper.DateCreate) }} ایجاد شده
                        است
                      </li>
                      <li class="txtRight text-primary">
                        <a :href="domain + finalizingPaper.AttachFile">
                          دانلود فایل ضمیمه
                        </a>
                      </li>
                      <li class="txtRight">
                        تعداد کلمات این پروژه
                        {{ finalizingPaper.TotalWord }} کلمه است
                      </li>
                      <li class="txtRight">
                        عنوان پروژه : {{ finalizingPaper.Title }}
                      </li>
                      <li class="txtRight">
                        توضیحات دانشجو : {{ finalizingPaper.Disc }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6 py-4">
              <div class="col-12">
                <div class="list-group-item list-group-item-action d-flex">
                  <div class="text-center">
                    <div class="course-overview-card">
                      <ul
                        class="generic-list-item generic-list-item-bullet fs-15"
                      >
                        <li class="txtRight">
                          با انجام این پروژه، مبلغ
                          {{ calcIncome(parseInt(finalizingPaper.TotalPrice)) }}
                          تومان به حساب شما واریز می شود.
                        </li>
                        <li class="txtRight">
                          این پروژه
                          {{ finalizingPaper.PaperServiceTypeName }} است.
                        </li>
                        <li class="txtRight">
                          نوع ژورنال
                          {{
                            findJournalType(finalizingPaper.JournalType)
                          }}
                          است.
                        </li>
                        <li class="txtRight">
                          زمان اخذ پذیرش
                          {{ findGrantTime(finalizingPaper.GrantTime) }} است.
                        </li>
                        <li class="txtRight">
                          حوزه تخصصی این پروژه
                          <span
                            :style="[
                              thisIsMyField(finalizingPaper.Field)
                                ? { color: 'green' }
                                : { color: 'orange' },
                            ]"
                            >{{ fieldName(finalizingPaper.Field) }}</span
                          >
                          است.
                        </li>
                        <li class="txtRight">
                          فوریت انجام این پروژه
                          <span
                            :style="[
                              finalizingPaper.Priority === 0
                                ? { color: 'green' }
                                : finalizingPaper.Priority === 1
                                ? { color: 'orange' }
                                : { color: 'red' },
                            ]"
                          >
                            {{
                              finalizingPaper.Priority === 0
                                ? "عادی"
                                : finalizingPaper.Priority === 1
                                ? "فوری"
                                : "خیلی فوری"
                            }}
                          </span>
                          است
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12 form-group">
              <label class="label-text">آپلود فایل نهایی</label>
              <div class="file-upload-wrap">
                <input
                  onfocus="this.removeAttribute('readonly');"
                  readonly
                  ref="inputFile"
                  multiple
                  type="file"
                  v-on:change="handleFileUpload($event)"
                  class="file-upload-input"
                />
                <span class="file-upload-text"
                  ><i class="la la-cloud-upload mr-2 fs-18"></i>فایل ها را اینجا
                  رها کنید یا برای آپلود کلیک کنید.</span
                >
              </div>
            </div>
            <div class="col-lg-12" v-for="f in file" :key="f">
              <span>فایل {{ f.name }} برای فایل های این دوره ذخیره شد</span>
            </div>
            <div class="col-12 py-4 form-group">
              <label class="label-text">توضیحات انجام پروژه</label>
              <CkEditor
                @sendContent="getContent"
                :content="initialData"
              ></CkEditor>
            </div>
          </div>
          <ProgressBar
            v-if="working"
            class="col-12"
            :showValue="working"
            :value="progressValue"
          />
          <div class="modal-footer">
            <button
              type="button"
              class="btn theme-btn"
              style="background-color: #f00"
              data-dismiss="modal"
            >
              لغو
            </button>
            <button
              @click="finalizePaper()"
              type="button"
              class="btn theme-btn"
              data-dismiss="modal"
            >
              ارسال فایل نهایی
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade modal-container" id="needChangeModal">
    <div class="modal-dialog bigMdl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">ارسال فایل نهایی</h3>
          <button type="button" class="close" data-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body px-5">
          <div class="row">
            <div class="col-6 py-4">
              <div class="list-group-item list-group-item-action d-flex">
                <div class="text-center">
                  <div class="course-overview-card">
                    <h3 class="txtRight fs-24 font-weight-regular pb-3">
                      درباره این پروژه
                    </h3>

                    <ul
                      class="generic-list-item generic-list-item-bullet fs-15"
                    >
                      <li class="txtRight">
                        این پروژه در تاریخ
                        {{ parseDates(needChangePaper.DateCreate) }} ایجاد شده
                        است
                      </li>
                      <li class="txtRight">
                        تعداد کلمات این پروژه
                        {{ needChangePaper.TotalWord }} کلمه است
                      </li>
                      <li class="txtRight">
                        فوریت انجام این پروژه
                        <span
                          :style="[
                            needChangePaper.Priority === 0
                              ? { color: 'green' }
                              : needChangePaper.Priority === 1
                              ? { color: 'orange' }
                              : { color: 'red' },
                          ]"
                        >
                          {{
                            needChangePaper.Priority === 0
                              ? "عادی"
                              : needChangePaper.Priority === 1
                              ? "فوری"
                              : "خیلی فوری"
                          }}
                        </span>
                        است
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6 py-4">
              <div class="col-12">
                <div class="list-group-item list-group-item-action d-flex">
                  <div class="text-center">
                    <div class="course-overview-card">
                      <ul
                        class="generic-list-item generic-list-item-bullet fs-15"
                      >
                        <li class="txtRight">
                          با انجام این پروژه، مبلغ
                          {{ calcIncome(parseInt(needChangePaper.TotalPrice)) }}
                          تومان به حساب شما واریز می شود.
                        </li>
                        <li class="txtRight">
                          این پروژه
                          {{ needChangePaper.PaperServiceTypeName }} است.
                        </li>
                        <li class="txtRight">
                          حوزه تخصصی این پروژه
                          <span
                            :style="[
                              thisIsMyField(needChangePaper.Field)
                                ? { color: 'green' }
                                : { color: 'orange' },
                            ]"
                            >{{ fieldName(needChangePaper.Field) }}</span
                          >
                          است.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12 form-group">
              <label class="label-text">آپلود فایل نهایی</label>
              <div class="file-upload-wrap">
                <input
                  onfocus="this.removeAttribute('readonly');"
                  readonly
                  ref="inputFile"
                  multiple
                  type="file"
                  v-on:change="handleNeedChangeFileUpload($event)"
                  class="file-upload-input"
                />
                <span class="file-upload-text"
                  ><i class="la la-cloud-upload mr-2 fs-18"></i>فایل ها را اینجا
                  رها کنید یا برای آپلود کلیک کنید.</span
                >
              </div>
            </div>
            <div class="col-12 py-4 form-group">
              <label class="label-text">توضیحات انجام پروژه</label>
              <CkEditorSecond
                @sendContentBio="getContentSecond"
                :contentBio="needChangeinitialData"
              >
              </CkEditorSecond>
            </div>
          </div>
          <ProgressBar
            v-if="working"
            class="col-12"
            :showValue="working"
            :value="progressValue"
          />
          <div class="modal-footer">
            <button
              type="button"
              class="btn theme-btn"
              style="background-color: #f00"
              data-dismiss="modal"
            >
              لغو
            </button>
            <button
              @click="finalizeNeedChangePaper()"
              type="button"
              class="btn theme-btn"
              data-dismiss="modal"
            >
              ارسال فایل نهایی
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade modal-container" id="moreModal">
    <div class="modal-dialog bigMdl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">جزییات بیشتر</h3>
          <button type="button" class="close" data-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body px-5">
          <div class="row">
            <div class="col-6 py-4">
              <div class="list-group-item list-group-item-action d-flex">
                <div class="text-center">
                  <div class="course-overview-card">
                    <ul
                      class="generic-list-item generic-list-item-bullet fs-15"
                    >
                      <li class="txtRight">
                        این پروژه در تاریخ
                        {{ parseDates(moreDataPaper.DateCreate) }} ایجاد شده است
                      </li>
                      <li class="txtRight text-primary">
                        <a :href="domain + moreDataPaper.AttachFile">
                          دانلود فایل ضمیمه
                        </a>
                      </li>
                      <li class="txtRight">
                        تعداد کلمات این پروژه {{ moreDataPaper.TotalWord }} کلمه
                        است
                      </li>
                      <li class="txtRight">
                        عنوان پروژه : {{ moreDataPaper.Title }}
                      </li>
                      <li class="txtRight">
                        توضیحات دانشجو : {{ moreDataPaper.Disc }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6 py-4">
              <div class="col-12">
                <div class="list-group-item list-group-item-action d-flex">
                  <div class="text-center">
                    <div class="course-overview-card">
                      <ul
                        class="generic-list-item generic-list-item-bullet fs-15"
                      >
                        <li class="txtRight">
                          با انجام این پروژه، مبلغ
                          {{ calcIncome(parseInt(moreDataPaper.TotalPrice)) }}
                          تومان به حساب شما واریز می شود.
                        </li>
                        <li class="txtRight">
                          این پروژه
                          {{ moreDataPaper.PaperServiceTypeName }} است.
                        </li>
                        <li class="txtRight">
                          نوع ژورنال
                          {{ findJournalType(moreDataPaper.JournalType) }} است.
                        </li>
                        <li class="txtRight">
                          زمان اخذ پذیرش
                          {{ findGrantTime(moreDataPaper.GrantTime) }} است.
                        </li>

                        <li class="txtRight">
                          حوزه تخصصی این پروژه
                          <span
                            :style="[
                              thisIsMyField(moreDataPaper.Field)
                                ? { color: 'green' }
                                : { color: 'orange' },
                            ]"
                            >{{ fieldName(moreDataPaper.Field) }}</span
                          >
                          است.
                        </li>
                        <li class="txtRight">
                          فوریت انجام این پروژه
                          <span
                            :style="[
                              moreDataPaper.Priority === 0
                                ? { color: 'green' }
                                : moreDataPaper.Priority === 1
                                ? { color: 'orange' }
                                : { color: 'red' },
                            ]"
                          >
                            {{
                              moreDataPaper.Priority === 0
                                ? "عادی"
                                : moreDataPaper.Priority === 1
                                ? "فوری"
                                : "خیلی فوری"
                            }}
                          </span>
                          است
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn theme-btn" data-dismiss="modal">
              بستن
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade modal-container" id="deleteFinalModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">حذف فایل نهایی</h3>
          <button type="button" class="close" data-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 py-4">
              <div
                style="border: none !important"
                class="justify-content-center list-group-item list-group-item-action d-flex"
              >
                <div class="text-center d-flex justify-content-center">
                  <div class="course-overview-card">
                    <h5 class="txtRight fs-14 font-weight-regular pb-3">
                      با انجام این کار این پروژه به بخش پروژه های در حال انجام
                      باز میگردد!
                    </h5>
                    <h4 class="d-flex justify-content-center">
                      آیا مطمئن هستید؟
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn theme-btn"
              style="background-color: #f00"
              data-dismiss="modal"
            >
              خیر
            </button>
            <button
              @click="deleteFinalFile(deleteFinalFilePaper.Uid)"
              type="button"
              class="btn theme-btn"
              data-dismiss="modal"
            >
              بله
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Toast position="top-left" />
</template>

<script>
import Preparing from "../components/Preparing.vue";
import NoArticle from "../components/NoArticle.vue";

import {
  donePapersFilters,
  articleFilters,
  teacherMajors,
  articleFilterCategories,
  grantDurations,
} from "../constants";
import axios from "axios";
import ls from "localstorage-slim";
import { DOMAIN } from "../configs";
import CkEditor from "../components/CkEditor.vue";
import CkEditorSecond from "../components/CkEditor2.vue";
import moment from "moment";
import { FilterMatchMode } from "primevue/api";

moment().format();

export default {
  name: "MyArticles",
  components: {
    Preparing,
    CkEditor,
    CkEditorSecond,
    NoArticle,
  },
  data() {
    return {
      articleFilterCategories: articleFilterCategories,
      grantDurations: grantDurations,
      progressValue: 0,
      needChangePapers: [],
      moreDataPaper: {},
      needChangePaper: {},
      working: false,
      inProgressPapers: [],
      filteredinProgressPapers: [],
      donePapers: [],
      finalFile: "",
      needChangefinalFile: "",
      ckContent: "",
      needChangeckContent: "",
      initialData: "",
      needChangeinitialData: "",
      domain: DOMAIN,
      finalizingPaper: {},
      deleteFinalFilePaper: {},
      me: {},
      pageNumber: 1,
      papers: [],
      isSorting: false,
      isPreparing: true,
      selectedfilter: 2,
      selectedfilterDonePapers: 2,
      selectedfilterCat: -1,
      selectedService: -1,
      filters: articleFilters,
      tableFilters: {},
      donePapersFilters: donePapersFilters,
      filterCats: teacherMajors,
      services: [],
      page: 1,
      perPage: 9,
      pages: [],
      file: "",
    };
  },
  computed: {
    // displayedpapers() {
    //   return this.paginate(this.filteredinProgressPapers);
    // },
  },
  async mounted() {
    this.initFilters();
    await this.getServices();
    this.me = JSON.parse(ls.get("user"));
    await this.getpapers();
    await this.getNeedChangePapers();
  },
  methods: {
    initFilters() {
      this.tableFilters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    async deleteFinalFile(uid) {
      if (this.deleteFinalFilePaper === {}) {
        this.$toast.add({
          severity: "error",
          summary: "خطا،مجدد تلاش کنید",
          life: 5000,
        });
        return;
      }
      this.working = true;
      await axios
        .post("/api/v1/teacher/paper/delete/final", {
          uid: uid,
        })
        .then((response) => {
          if (response.status === 200 && response.data.data === "ok") {
            this.getpapers();
            this.working = false;
            // this.donePapers = this.donePapers.filter((pp)=>pp.Uid!==uid)
            // this.inProgressPapers.push()
            this.$toast.add({
              severity: "success",
              summary: "فایل نهایی این پروژه حذف شد",
              life: 10000,
            });
          } else {
            this.working = false;
            this.$toast.add({
              severity: "error",
              summary: "خطا در انجام عملیات",
              detail: "لطفا مجدد تلاش کنید",
              life: 5000,
            });
          }
        });
      await this.getpapers();
      await this.getNeedChangePapers();
    },
    handleFileUpload(event) {
      this.finalFile = event.target.files;
    },
    handleNeedChangeFileUpload(event) {
      this.needChangefinalFile = event.target.files;
    },
    getContent(e) {
      this.ckContent = e;
    },
    getContentSecond(e) {
      this.needChangeckContent = e;
    },
    thisIsMyField(f) {
      return f == this.me.Field;
    },
    calcIncome(p) {
      return parseInt((p * this.me.CutOff) / 100);
    },
    sendPaper(p) {
      this.finalizingPaper = p;
    },
    sendNeedChangePaper(p) {
      this.needChangePaper = p;
    },
    async finalizePaper() {
      if (this.finalizingPaper === {}) {
        this.$toast.add({
          severity: "error",
          summary: "خطا،مجدد تلاش کنید",
          life: 5000,
        });
        return;
      }
      this.working = true;
      let formData = new FormData();

      formData.append("File", this.finalFile[0]);
      formData.append("finaldisc", this.ckContent);
      formData.append("uid", this.finalizingPaper.Uid);

      await axios
        .post("/api/v1/teacher/paper/final", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            this.progressValue = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then((response) => {
          if (response.status == 200 && response.data.data === "ok") {
            this.working = false;
            this.$toast.add({
              severity: "success",
              summary: "فایل نهایی با موفقیت ارسال شد",
              life: 5000,
            });
            this.progressValue = 0;
            this.inProgressPapers = this.inProgressPapers.filter(
              (p) => this.finalizingPaper.Uid !== p.Uid
            );
            this.finalFile = "";
            this.$refs.inputFile.value = null;
            this.working = false;
          } else {
            this.working = false;

            this.$toast.add({
              severity: "error",
              summary: "لطفا مجدد تلاش کنید یا خطاها را برطرف کنید",
              life: 5000,
            });
          }
        })
        .catch((e) => {
          this.$toast.add({
            severity: "error",
            summary: "خطای سرور",
            life: 5000,
          });
          this.progressValue = 0;
          this.working = false;
        });
      await this.getpapers();
      await this.getNeedChangePapers();
    },
    async finalizeNeedChangePaper() {
      if (this.needChangePaper === {}) {
        this.$toast.add({
          severity: "error",
          summary: "خطا،مجدد تلاش کنید",
          life: 5000,
        });
        return;
      }
      this.working = true;
      let formData = new FormData();

      formData.append("File", this.needChangefinalFile[0]);
      formData.append("finaldisc", this.needChangeckContent);
      formData.append("uid", this.needChangePaper.Uid);

      await axios
        .post("/api/v1/teacher/paper/final", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            this.progressValue = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then((response) => {
          if (response.status == 200 && response.data.data === "ok") {
            this.working = false;
            this.$toast.add({
              severity: "success",
              summary: "فایل نهایی با موفقیت ارسال شد",
              life: 5000,
            });
            this.progressValue = 0;

            this.needChangefinalFile = "";
            this.$refs.inputFile.value = null;
            this.working = false;
          } else {
            this.working = false;

            this.$toast.add({
              severity: "error",
              summary: "لطفا مجدد تلاش کنید یا خطاها را برطرف کنید",
              life: 5000,
            });
          }
        })
        .catch((e) => {
          this.$toast.add({
            severity: "error",
            summary: "خطای سرور",
            life: 5000,
          });
          this.progressValue = 0;
          this.working = false;
        });
      await this.getpapers();
      await this.getNeedChangePapers();
    },
    fieldName(f) {
      if (this.filterCats.find((ff) => ff.code === f) !== undefined) {
        return this.filterCats.find((ff) => ff.code === f).name;
      } else {
        return "نامشخص";
      }
    },
    async getServices() {
      var response = await axios.get("/api/v1/teacher/paper/service");
      this.services = response.data;
    },
    scrollToTop() {
      document.getElementById("app").scrollIntoView({ behavior: "smooth" });
    },
    async getpapers() {
      await axios
        .post("/api/v1/teacher/paper/mypaper", { uidteach: this.me.Uid })
        .then((response) => {
          if (response.status === 200) {
            this.papers = response.data;
            this.donePapers = this.papers.filter((p) => p.Status === 5);
            this.inProgressPapers = this.papers.filter((p) => p.Status !== 5);
            this.filteredinProgressPapers = this.inProgressPapers;
            this.selectedfilterCat = this.me.Field;
            this.isPreparing = false;
          }
        });
    },
    async getNeedChangePapers() {
      await axios
        .post("/api/v1/teacher/paper/need/check", { uidteach: this.me.Uid })
        .then((response) => {
          if (response.status === 200) {
            this.needChangePapers = response.data;
            this.isPreparing = false;
          }
        });
    },
    setPages() {
      let numberOfPages = Math.ceil(
        this.filteredinProgressPapers.length / this.perPage
      );
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(papers) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return papers.slice(from, to);
    },
    findJournalType(inputValue) {
      if (inputValue) {
        return this.articleFilterCategories.find((item) => {
          return item.code === Number(inputValue);
        }).name;
      }
    },
    findGrantTime(inputValue) {
      if (inputValue) {
        return this.grantDurations.find((item) => {
          return item.code === Number(inputValue);
        }).name;
      }
    },
  },
};
</script>
